import { useEffect, useRef } from 'react';
import { useProgress } from '../context/ProgressContext';
import { ModuleType } from '../types/progress';

export const useVideoProgress = (moduleType: ModuleType) => {
  const { markAsCompleted } = useProgress();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      markAsCompleted(moduleType, 'video', `${moduleType}-video`);
    };

    const handleTimeUpdate = () => {
      // Mark as completed if user has watched 90% of the video
      if (video.currentTime / video.duration >= 0.9) {
        markAsCompleted(moduleType, 'video', `${moduleType}-video`);
      }
    };

    video.addEventListener('ended', handleEnded);
    video.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      video.removeEventListener('ended', handleEnded);
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [moduleType, markAsCompleted]);

  return videoRef;
};
